import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const BULLETS = ['Leen por iniciativa propia: sin pelear, sin rogar, sin negociar', 'Cada historia con su referencia bíblica, para dar el salto a la Biblia real', 'En su tablet, en tu celular o impresa: la llevas a todos lados'];
export function Hero() {
  return <section className="w-full bg-[#10243D]" data-id="element-65" data-mp="129qvjoortvpg">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-8 px-4 py-14 md:grid-cols-12 md:gap-12 md:py-20" data-id="element-66" data-mp="127edzcmxdncx">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="md:col-span-7" data-id="element-67" data-mp="sb1axo5hpx5i">
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.15em] text-gold sm:text-sm" data-id="element-68" data-mp="3d1ikl9ryvcnf">
            La Biblia completa en formato cómic · De Génesis a Apocalipsis
          </p>
          <h1 className="font-sans text-[32px] font-extrabold uppercase leading-[1.08] tracking-[-0.035em] text-white sm:text-5xl md:text-[54px]" data-id="element-69" data-mp="384s6grzq2r4n">
            Tu hijo cree que la Biblia es{' '}
            <span className="mark-gold" data-id="element-70" data-mp="3o5j2h85axfkr">aburrida</span>. Hasta que ve esta.
          </h1>

          <motion.img initial={{
          opacity: 0,
          y: 18,
          scale: 0.98
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} transition={{
          duration: 0.65,
          delay: 0.15
        }} src="https://cdn.magicpatterns.com/uploads/7Z5tmMKuRKz1jTHUZwXgJY/mockup.png" alt="La Biblia en Cómic mostrada en tablet, celular y en versión impresa" className="mx-auto mt-7 w-full max-w-md rounded-card shadow-2xl md:mx-0" data-id="element-71" data-mp="39a38120t7hnu" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 18
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.12
      }} className="md:col-span-5" data-id="element-72" data-mp="2vjg6l23nzdo2">
          <p className="text-[17px] leading-relaxed text-cream/90 md:text-lg" data-id="element-73" data-mp="2lk8wqow5215p">
            Historias fieles a la Escritura, ilustradas como sus historietas
            favoritas, para que la Palabra deje de ser una obligación y se
            convierta en su historia favorita.
          </p>

          <ul className="mt-7 space-y-4" data-id="element-74" data-mp="icrpetr2yrat">
            {BULLETS.map(b => <li key={b} className="flex items-start gap-3" data-id="element-75" data-mp="de6o0r03e1ks">
                <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-gold" data-id="element-76" data-mp="1b0vvhgdkd6e1">
                  <CheckIcon className="h-4 w-4 text-deep-blue" aria-hidden="true" data-id="element-77" data-mp="161axp9a4r42w" />
                </span>
                <span className="text-[16px] leading-relaxed text-cream md:text-[17px]" data-id="element-78" data-mp="1126mkd3naw9x">
                  {b}
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex justify-center md:justify-start" data-id="element-79" data-mp="3lsp1j88sy9bs">
            <CtaButton label="QUIERO QUE AME LA PALABRA" size="lg" onDark data-id="element-80" data-mp="3lque9na2654j" />
          </div>
        </motion.div>
      </div>

      <div className="border-t border-gold/30 bg-[#10243D]" data-id="element-81" data-mp="1x9b6134gx5dm">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-center gap-2 px-4 py-5 text-center sm:flex-row sm:gap-3" data-id="element-82" data-mp="1xavvwffu8055">
          <span className="flex text-gold" aria-hidden="true" data-id="element-83" data-mp="269zj9vm1f1pg">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold" data-id="element-84" data-mp="2b1932fkwnatf" data-mpi={i} />)}
          </span>
          <p className="text-sm font-medium text-cream/80 md:text-[15px]" data-id="element-85" data-mp="2g0bzxcqqeaqb">
            El formato que ya conquistó a millones de familias en todo el mundo
          </p>
        </div>
      </div>
    </section>;
}